import React from 'react';
import PropTypes from 'prop-types';
import TABLER_ICON_PATHS from '../../../catering/portal/tablerIcons';

// Inline-SVG Tabler icons for the vendor schedule + notifications surfaces.
// The customer portal already carries the bulk of the path table
// (catering/portal/tablerIcons.js, generated — not edited here); this adds
// only the handful of names the vendor-schedule frames use that the portal
// set lacks. Paths from @tabler/icons 3.x (MIT), unchanged.
const EXTRA_PATHS = {
  'selector': 'M8 9l4 -4l4 4|M16 15l-4 4l-4 -4',
  'chevron-down': 'M6 9l6 6l6 -6',
  'dots-vertical': 'M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0|M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0|M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0',
  'alert-triangle': 'M12 9v4|M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z|M12 16h.01',
  'help': 'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0|M12 17l0 .01|M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4',
  'clipboard-list': 'M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2|M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z|M9 12l.01 0|M13 12l2 0|M9 16l.01 0|M13 16l2 0',
  'chef-hat': 'M12 3c1.918 0 3.52 1.35 3.91 3.151a4 4 0 0 1 2.09 7.723v7.126h-12v-7.126a4 4 0 1 1 2.092 -7.723a4 4 0 0 1 3.908 -3.151z|M6.161 17.009l11.839 -.009',
  'calendar-check': 'M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6|M16 3v4|M8 3v4|M4 11h16|M15 19l2 2l4 -4',
  'user-off': 'M8.18 8.189a4.01 4.01 0 0 0 2.616 2.627m3.507 -.545a4 4 0 1 0 -5.59 -5.552|M6 21v-2a4 4 0 0 1 4 -4h4c1.207 0 2.276 .535 3.006 1.38m.945 3.062c.032 .182 .049 .368 .049 .558v2|M3 3l18 18',
  'certificate': 'M15 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0|M13 17.5v4.5l2 -1.5l2 1.5v-4.5|M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73|M6 9l12 0|M6 12l3 0|M6 15l2 0',
  'map-pin-filled': 'M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z',
  // Notifications surfaces (design/notifications-v2.dc.html).
  'shield-x': 'M13.252 20.601c-.408 .155 -.826 .288 -1.252 .399a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .116 6.376|M22 22l-5 -5|M17 22l5 -5',
  'brand-instagram': 'M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z|M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0|M16.5 7.5l0 .01',
  'calendar-x': 'M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8|M16 3v4|M8 3v4|M4 11h16|M22 22l-5 -5|M17 22l5 -5',
  'message-dots': 'M12 11v.01|M8 11v.01|M16 11v.01|M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z',
  'speakerphone': 'M18 8a3 3 0 0 1 0 6|M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5|M12 8h0l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8',
  'bell-check': 'M11.5 17h-7.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1.5|M9 17v1a3 3 0 0 0 3.51 2.957|M15 19l2 2l4 -4',
  'cloud-off': 'M9.58 5.548c.24 -.11 .492 -.207 .752 -.286c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 .957 -.383 1.824 -1.003 2.454m-2.997 1.029h-11.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.13 -.582 .37 -1.128 .7 -1.62|M3 3l18 18',
  'filter-off': 'M8 4h12v2.172a2 2 0 0 1 -.586 1.414l-3.914 3.914m-.5 3.5v4l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227|M3 3l18 18',
};

export default function Ticon({ name, size = 18, className, ...rest }) {
  const paths = EXTRA_PATHS[name] || TABLER_ICON_PATHS[name];
  if (!paths) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Ticon: unknown icon "${name}"`); // eslint-disable-line no-console
    }
    return null;
  }

  const filled = name.endsWith('-filled');

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={filled ? undefined : 2}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
      {...rest}
    >
      {paths.split('|').map((d) => <path key={d} d={d} />)}
    </svg>
  );
}

Ticon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};
